import script from "./GroupNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupNavigation.vue?vue&type=script&setup=true&lang=js"

import "./GroupNavigation.vue?vue&type=style&index=0&id=f856c138&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f856c138"]])

export default __exports__